import React from "react";
import Parse from "parse";

import { AdminLayout, useTranslation } from "@opendash/core";

export const ImportReferenceRoute = React.memo(function ImportReferenceRoute() {
  const t = useTranslation();

  return (
    <AdminLayout contentPadding>
      <p style={{ textAlign: "center" }}>Coming soon?</p>
    </AdminLayout>
  );
});
